export const BIRTHDAY_HEADER_CLOSED_LOCAL_STORAGE_KEY = "isBirthdayHeaderClosed";

export const FIRST_TIME_WAITING_QUEUE_MODAL_KEY = "isFirstTimeWaitingQueueModal";

// start date = 14th of Feb 2025, 12:01am EST
export const SALE_START_TIME = new Date("2025-02-13T21:01:00.000Z");
// end date = 15th of Feb 2025, at 02:59am EST
export const SALE_END_TIME = new Date("2025-02-15T07:59:00.000Z");
